/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BulkAddBrandsRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {BulkAddBrandsResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const bulkAddBrands = (request: BulkAddBrandsRequest, options?: CashRequestOptions) => post<BulkAddBrandsRequest, BulkAddBrandsResponse>("/cash-app/local/brands/add", request, {...options, rejectOnError: true })